module.exports = __webpack_public_path__ + "3ab47114bf493274161456dbcb0596ef.png";